// extracted by mini-css-extract-plugin
export var bodyRow = "_e7-d";
export var cardColumns = "_e7-e";
export var ellipsesOverflow = "_e7-2";
export var flatBottomCorners = "_e7-3";
export var flatTopCorners = "_e7-4";
export var headerActionsDropdown = "_e7-f";
export var headerBottomRow = "_e7-c";
export var headerTopRow = "_e7-b";
export var orderDetailsWrapper = "_e7-0";
export var orderInfoContainer = "_e7-1";
export var productDetails = "_e7-9";
export var productImage = "_e7-5";
export var responsiveTable = "_e7-8";
export var shipmentContainer = "_e7-a";
export var tableBottomLeft = "_e7-6";
export var tableBottomRight = "_e7-7";
export var trackingLink = "_e7-g";